import { Box, Group, Text } from '@mantine/core';
import React from 'react';

export interface IPropertyListItem {
  label: string;
  value: React.ReactNode;
}

export interface IPropertyListProps {
  items: IPropertyListItem[];
  size?: 'xs' | 'sm';
}

/** @registry Borderless label/value definition list (dimmed label left, full-contrast value right); use for property/metadata blocks instead of a bordered table or Grid. */
export const PropertyList: React.FC<IPropertyListProps> = ({
  items,
  size = 'sm',
}) => (
  <Box
    component="dl"
    m={0}
    style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
  >
    {items.map((item) => (
      <Group
        key={item.label}
        justify="space-between"
        align="flex-start"
        wrap="nowrap"
        gap="sm"
      >
        <Text component="dt" size={size} c="dimmed">
          {item.label}
        </Text>
        <Text component="dd" size={size} c="bright" ta="right" m={0}>
          {item.value}
        </Text>
      </Group>
    ))}
  </Box>
);
